import { render, staticRenderFns } from "./rlbout.vue?vue&type=template&id=5fd44dcc&scoped=true&"
import script from "./rlbout.vue?vue&type=script&lang=js&"
export * from "./rlbout.vue?vue&type=script&lang=js&"
import style0 from "./rlbout.vue?vue&type=style&index=0&id=5fd44dcc&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fd44dcc",
  null
  
)

export default component.exports